import React, {useEffect, useState} from 'react'
import _ from 'lodash/fp'
import {isMobile} from '@startlibs/utils'



export const useWhenApplyShadow = (tableRef) => {

  const getPixelsToEnd = () => {
    const scrollElement = (isMobile() ? tableRef.current : document.body)
    const scrollLeft = (isMobile() ? tableRef.current.scrollLeft : window.pageXOffset)

    const availableScroll = scrollElement.scrollWidth-scrollElement.offsetWidth
    return [availableScroll - scrollLeft,availableScroll>0]
  }

  const [[pos,hasScroll],setPos] = useState([0,false])

  useEffect(() => {
    const onScroll = _.throttle(100,() => {
      setPos(getPixelsToEnd())
    })
    const element = (isMobile() ? tableRef.current : window)
    element.addEventListener("scroll",onScroll)
    element.addEventListener("resize",onScroll)
    setPos(getPixelsToEnd())
    return () => {
      element.removeEventListener("scroll",onScroll)
      element.removeEventListener("resize",onScroll)
    }
  },[])



  return hasScroll && (isMobile() ? pos > 0 : pos > 30)
}